<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="section__content center login">
          <form v-on:submit.prevent="login">
            <h1 class="std__subtile">{{$t("login_title")}}</h1>
            <h2 class="std__subtile md">
              {{$t("confirmation")}}
            </h2>
            <div class="mobiForElm">
              <input
                type="tel"
                class="mobiForElm__input"
                v-model="msisdn"
                maxlength="14"
                placeholder
              />
            </div>
            <div class="btnContainer">
              <button type="submit" class="mobiBtn">{{$t("submit")}}</button>
            </div>
            <div
              v-if="showStatusAlert"
              class="alert alert-danger col-md-3"
              role="alert"
            >
              <span v-if="lang_mobiz === 'english'">{{ status }}</span>
              <span v-if="lang_mobiz !== 'english'">{{ statusTran }}</span>
              <!-- <span v-if="lang_mobiz === 'english'">{{ status }}</span>
              <span v-if="lang_mobiz === 'arabic'">{{ statusAR }}</span>
              <span v-if="lang_mobiz === 'greek'">{{ statusGR }}</span>
              <span v-if="lang_mobiz === 'malay' || lang_mobiz === 'indonesian'">{{ statusMYID }}</span> -->
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
            <div
              v-if="showMsisdnAlert"
              class="alert alert-danger col-md-5"
              role="alert"
            >
              {{$t("valid_number")}}
              <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close" @click="close()">×</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import mobizone from "../../../router/mobizone";
import country_list from "../../../locales/country_list.json";
import EventBus from "../../EventBus.vue";
import { mapActions, mapGetters } from "vuex";

const proxyurl = "http://api.allorigins.win/get?url="; //prevent CORS

export default {
  data() {
    return {
      msisdn: "",
      status: "",
      statusTran: "",
      showMsisdnAlert: false,
      showStatusAlert: false,
      src: "en",
      dest: "ar",
      dest1: "el"
    };
  },
  created(){
    this.getPrefix(this.country_mobiz)
  },
  computed: mapGetters(["lang_mobiz", "gcid_mobiz" ,"country_mobiz"]),
  methods: {
    getPrefix(country){
      for (let [key, value] of Object.entries(country_list)) {
        if(country == key){
          this.msisdn = '+'+value.prefix;
        }
      }
    },
    close(){
      this.showMsisdnAlert = false;
      this.showStatusAlert = false;
    },
    login() {
      let regex = /^\d{9,}$/;
      let a = this.msisdn;
      this.msisdn = a.replace("+","");

      if (this.msisdn == "") {
        this.showMsisdnAlert = true;
      } else {
        if (regex.test(this.msisdn) == false) {
          this.showMsisdnAlert = true;
        } else {
          let gcid = "";
          if(this.gcid_mobiz != ""){
            gcid = this.gcid_mobiz
          }else{
            //dummy gcid
            gcid = "264";
          }
          
          let data = {
            msisdn: this.msisdn,
            gcid: gcid,
            verbose: "1"
          };

          const login = {
            url: `${proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?msisdn=${data.msisdn}&gcid=${data.gcid}&verbose=${data.verbose}`),
            method: "POST"
          };
          this.$axios(login)
            .then(res => {
              var response = JSON.parse(res.data.contents);
              if (response.status == "active") {
                localStorage.setItem("userToken_mobiz", response.token);
                localStorage.setItem("userProfile_mobiz",  res.data.contents)
                this.msisdn = "";
                // this.emitMethod();
                this.login_mobiz("loggedin");
                mobizone.push({ name: "Main" }).catch(err => {});
                location.reload();
              } else if (response.status == "inactive") {
                this.showStatusAlert = true;
                this.showMsisdnAlert = false;
                let status = response.status.replace( response.status.toUpperCase());
                this.status = status;

                for (let [key, value] of Object.entries(country_list)) {
                  if(this.country_mobiz == key){
                    let status_lang = require(`../../../locales/mobizone/${value.language}.json`);
                    this.statusTran = status_lang.status;
                  }
                }
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },
    ...mapActions(["login_mobiz"])
    // emitMethod() {

    // }
  }
};
</script>

<style lang="scss" scoped>
.section__content.login {
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
input.mobiForElm__input {
  direction: ltr;
}
.alert {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/mobizone/Login.vue